import HeroSection from '../components/HeroSection/HeroSection';

const HomePage = () => {
  return <HeroSection />;
};

export default HomePage;
